/** Small drawing helpers shared by the Renderer and its passes (render/passes). */
import type { Entity } from '@nine/shared';
import { visualScale, type SpriteBank } from './sprites';

/**
 * Dressed figures on screen past which only the player's cloth streams in the wind (and crowds
 * of townsfolk share their name tags).
 */
export const CROWD = 24;

/** Out of sight: townsfolk indoors, birds flown off. */
export const hidden = (e: Entity): boolean => !!e.folk?.indoors || e.critter?.state === 'gone';

/** A figure's drawn height in pixels, from its feet. */
export function heightOf(sprites: SpriteBank, e: Entity): number {
  const set = sprites.of(e);
  return (set?.h ?? 56) * visualScale(e, set);
}

/** Starts a path round an ellipse (radii at least half a pixel), for the caller to fill or stroke. */
export function ellipse(g: CanvasRenderingContext2D, x: number, y: number, rx: number, ry: number): void {
  g.beginPath();
  g.ellipse(x, y, Math.max(0.5, rx), Math.max(0.5, ry), 0, 0, Math.PI * 2);
}
